
<template>
<div >

    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title"><b>#{{ invoicedata.invoice_number }}: GIẤY BÁO TIỀN ĐIỆN, NƯỚC {{convertDateMonth(invoicedata.date_issued)}} ({{convertDateVN(invoicedata.date_issued)}})</b></h3>
        <!-- <h3 class="box-title pull-right">{{ $t(`invoice.invoice`) }}</h3> -->
        <button
            type="button"
            class="btn btn-labeled btn-warning pull-right"
            @click="onClickOpenInvoice"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-usd"></i>
            </span>
            {{ $t(`invoice.invoice`) }}
          </button>
      </div>

      <div class="box-body">
        <div class="row">
          <div class="col-sm-12">
            <!-- <b>{{this.getFullNameByLanguage(null)}}</b> -->
            <div class="row">
              <div class="col-md-3 col-lg-3">
                <b>{{ $t(`invoice.resident_fullname`) }}:</b>
                {{invoicedata.resident_fullname}}
              </div>

              <div class="col-md-3 col-lg-3">
                <b>{{$t('invoice.resident_address')}}:</b>
                {{invoicedata.resident_address}}
              </div>

            </div>
          </div>
        </div>

        <br />

        <div class="row">
                <div class="col-md-12 col-xs-12">
                    <table class="table table_total_fee ">
                        <thead class="text-center">
                            <!---->
                            <tr>
                                <th class="text-center"><b> Khoản mục</b></th>
                                <th class="text-center">Nợ phí cũ</th>
                                <th class="text-center">Chỉ số tiêu hao</th>
                                <th class="text-center">Đơn giá</th>
                                <th class="text-center">Phí dịch vụ kỳ này</th>
                                <th class="text-center">Thuế GTGT</th>
                                <th class="text-center">Tổng Cộng</th>
                            </tr>
                        </thead>
                        <tbody class="">
                            <tr v-for="entry in itemServices" :key="entry.id" :uId="entry.id">
                                <template v-if="entry.id != ''">
                                    <td v-for="key in fields" :key="key.id">
                                        <p v-if="key['key'] == 'total_fees' || key['key'] == 'total_all'" style="text-align:right">{{formatTotalFee(entry[key["key"]])}}</p>
                                        <p v-else-if="key['key'] == 'vatAmount' || key['key'] == 'price_unit'" style="text-align:right">{{formatTotalFee(entry[key["key"]], true)}}</p>
                                        <p v-else>{{entry[key["key"]]}}</p>
                                        </td>
                                </template>
                            </tr>
                            <tr>
                                <td style="background-color:#66FFFF" colspan="6" class="text-center"><b>TỔNG PHÍ DỊCH VỤ THANH TOÁN</b><i>/ GRAND TOTAL</i></td>
                                <td style="background-color:#66FFFF;text-align:right" colspan="1">{{formatTotalFee(sum_total)}}</td>
                            </tr>
                        </tbody>

                        <tfoot class="">
                            <td style="background-color:#66FFFF; padding-left: 30px; font-size:15px" colspan="7" class=""  >
                                Số tiền bằng chữ: <b>{{readMoney(sum_total, "vi")}} ./.</b>
                                <br/>
                                <i>(Amount in words: {{readMoney(sum_total, "en")}} ./.)</i>
                            </td>
                        </tfoot>

                    </table>
                </div>
            </div>
      </div>
    </div>
        <lte-modal v-show="isModalVisible" @onConfirm="onConfirm" @close="closeModal" v-for="obj in objModal" :key="obj.id" :item="obj"></lte-modal>
        <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
        <router-view></router-view>
    </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import {
    mapGetters,
    mapActions
} from "vuex";

import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

// https://vue-multiselect.js.org/
import "vue-multiselect/dist/vue-multiselect.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// import Multiselect from "vue-multiselect";
import LTEModal from "@/components/LTEModal.vue";
import utils from "@/lib/utils";

export default {
    props:  ["item"],
    name: "SearchInvoiceInfo",
    data() {
        return {
            // fields for show list service Usage
            fields: [
                // {
                //   key: "service_usage_id",
                //   label: "Ref Usage ID",
                //   sortable: true,
                //   sortDirection: "desc"
                // },
                {
                    key: "service_name",
                    label: "Khoản mục",
                    sortable: true,
                    sortDirection: "desc"
                },
                // {
                //   key: "service_code",
                //   label: "Service Code",
                //   sortable: true,
                //   class: "text-center"
                // },
                // {
                //   key: "date_from",
                //   label: "Date From",
                //   sortable: true,
                //   class: "text-center"
                // },
                // {
                //   key: "date_to",
                //   label: "Date To",
                //   sortable: true,
                //   class: "text-center"
                // },
                {
                    key: "old_debt",
                    label: "Nợ phí cũ",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "consumption",
                    label: "Chỉ số tiêu hao",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "price_unit",
                    label: "Đơn Giá",
                    sortable: true,
                    sortDirection: "desc"
                },
                {
                    key: "total_fees",
                    label: "Thành tiền ",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "vatAmount",
                    label: "VAT",
                    sortable: true,
                    sortDirection: "desc"
                },
                // {
                //   key: "status",
                //   label: "Status",
                //   sortable: true,
                //   class: "text-center"
                // },
                {
                    key: "total_all",
                    label: "Tổng Cộng",
                    sortable: true,
                    class: "text-center"
                }
                // { key: "actions", label: "Actions", class: "text-center" }
            ],
            // data for show list service Usage
            itemServices: [],
            sum_total: 0,
            isWater : false,
            isElectronic : false,
            // MultiSelect Service availabe
            // optionServiceSelected: null, //[{ name: 'Javascript', code: 'js' }]
            // optionServices: [], //[{"name":"Vue.js","code":"vu"},{"name":"Javascript","code":"js"},{"name":"Open Source","code":"os"}],

            // disabledOptionServices: true,
            service_usage_list: [],

            form: {
                date_issued: new Date(),
                date_paid: new Date(),
                service: null,
                device: null,
                user: this.$route.params.id
            },
            options: {
                format: "DD/MM/YYYY"
            },
            actionType: "",

            // Customer List
            customerList: [{
                value: null,
                text: "Select One"
            }], //[{"value":1,"text":"Loi"},{"value":2,"text":"Loc"},{"value":3,"text":"Tuan"},{"value":4,"text":"Hung"},{"value":5,"text":"Hau"}]
            customerSelected: null,
            disabledCustomerList: true,

            // Status Invoice List
            statusList: [{
                value: null,
                text: "Select One"
            }], //[{"value":1,"text":"Issue"},{"value":2,"text":"Paid"},{"value":3,"text":"Cancelled"}]
            statusSelected: null,
            disabledStatusList: false,

            show: false,
            invoicedata: {
                id: 0,
                invoice_number: "",
                invoice_user: null,
                invoice_status: 1, // set default is Issued
                invoice_status_name: "",
                date_issued: "",
                date_paid: "",
                other_details: "",

                mainowner_fullname: "",
                mainowner_address: "",
                mainowner_email: "",
                mainowner_country: "",
                mainowner_phone: "",
                mainowner_tax: "",

                resident_fullname: "",
                resident_address: "",
                resident_email: "",
                resident_country: "",
                resident_phone: "",
                resident_tax: "",

                account_no: "",
                account_name: "",
                transferring_content: "",
                contact_us: "",
            },

            isModalVisible: false,
            objModal: [{
                title: "Add Configuration",
                body: "Are you sure you want to add the record?",
                buttonNo : "common.delete_modal.btnNo",
                buttonYes: "common.delete_modal.btnYes",
                styleType: "default"
            }]
        };
    },
    watch: {

    },
    computed: {
        functionExample: function () {
            return "";
        },
        ...mapGetters([
            "INVOICE_DETAIL_DATA",
            "GET_SNACK_BAR"
        ])
    },
    methods: {
        onClickOpenInvoice: function() {
          let routeData = this.$router.resolve({
            name: "InvoiceAdd",
            params: {
              id: this.item.id
            }
          });
          window.open(routeData.href, "_blank");
        },
        readMoney: function(number, locale){
            return utils.readMoney(number, locale)
        },

        closeModal() {
            this.isModalVisible = false;
        },
        ...mapActions([
            "ERROR_TOAST",
            "SUCCESS_TOAST"
        ]),

        CancelInvoiceList: function () {
            this.$router.push({
                name: "InvoiceList"
            });
        },
        onConfirm: function () {
            this.isModalVisible = false;
        },

        printInvoice: function () {
            document.getElementById("cmdCancel").style.display = "none";
            document.getElementById("cmdPrintPdf").style.display = "none";
            window.print();
            document.getElementById("cmdCancel").style.display = "";
            document.getElementById("cmdPrintPdf").style.display = "";
        },

        convertDateVN(date){
            // Day
            let day = utils.formatSqlDate(date, null, "DD")
            // Month
            let month = utils.formatSqlDate(date, null, "MM")
            // Year
            let year = utils.formatSqlDate(date, null, "YYYY")
            return "Ngày " + day + " tháng " + month +  " năm " + year
        },
        convertDateMonth(date){
            // Month
            let month = utils.formatSqlDate(date, null, "MM")
            // Year
            let year = utils.formatSqlDate(date, null, "YYYY")
            return " tháng " + month +  " năm " + year
        },
        convertDateEN(date){
            return utils.formatSqlDate(date, null, "DD MMM YYYY")
        },

        formatTotalFee(total_fee, isFormat = false){
            if(total_fee != undefined){
                total_fee = utils.makeRoundNumber(total_fee)
                let rs = total_fee.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                return  (rs == 0 && isFormat) ? "-" : rs;
            }
        },
        formatDate(date){
            return utils.formatSqlDate(date, null, "DD/MM/YYYY")
        }
    },
    mounted() {
        this.invoicedata.invoice_number = this.item.invoice_number;
        // this.invoicedata.invoice_user = this.item.user.id;

        if (this.item.invoice_to_company_flag) {
            // Company
            // this.invoicedata.resident_fullname =
            //     this.INVOICE_DETAIL_DATA.user.company_name + " - (C) ";
            this.invoicedata.resident_fullname =
                this.item.user.company_name;
            this.invoicedata.resident_tax = this.item.user.company_tax_code;
            this.invoicedata.resident_address = this.item.user.company_address;
        } else {
            // Customer
            // this.invoicedata.resident_fullname =
            //     this.INVOICE_DETAIL_DATA.user.name + " - (P) ";
            this.invoicedata.resident_fullname = this.item.user.name;
            this.invoicedata.resident_tax = this.item.user.personal_tax_code;
            this.invoicedata.resident_address = this.item.apartment.apartment_code;
        }


        this.itemServices =  this.item.service_usage_list
        let initialValue = 0
        this.sum_total = this.itemServices.reduce(function (total, currentValue) {
                    return total + currentValue.total_all;
                }, initialValue);


        this.invoicedata.resident_country = this.item.user.country_name;
        this.invoicedata.resident_email = this.item.user.email;
        this.invoicedata.resident_phone = this.item.user.phone;

        this.invoicedata.invoice_status = this.item.invoice_status.id;
        this.invoicedata.invoice_status_name = this.item.invoice_status.status_description;

        this.invoicedata.other_details = this.item.other_details;

        if (this.item.date_issued == null) {
            this.form.date_issued = new Date();
        } else {
            this.form.date_issued = this.item.date_issued;
        }
        this.invoicedata.date_issued = utils.formatSqlDate(this.form.date_issued, null, "DD-MMM-YYYY");
        if (this.item.due_date == null) {
            this.form.due_date = "";
        } else {
            this.form.due_date = this.item.due_date;
        }

        this.invoicedata.due_date = utils.formatSqlDate(this.form.due_date, null, "DD-MMM-YYYY", "");
        if (this.item.date_paid == null) {
            this.form.date_paid = new Date();
        } else {
            this.form.date_paid = this.item.date_paid;
        }
        this.invoicedata.date_paid = utils.formatSqlDate(this.form.date_paid, null, "DD-MMM-YYYY");



        this.invoicedata.account_no =  '';
        this.invoicedata.account_name = '';
        this.invoicedata.transferring_content = "";
        this.invoicedata.contact_us = '';


        this.isElectronic = true
        this.isWater = true

    },
    components: {
        "lte-core-alert": LTECoreAlert,
        // Multiselect,
        "lte-modal": LTEModal
    }
};
</script>

<style scoped>
.btn-label {
    position: relative;
    left: -12px;
    display: inline-block;
    padding: 6px 12px;
    background: rgba(0, 0, 0, 0.15);
    border-radius: 3px 0 0 3px;
}

.btn-labeled {
    padding-top: 0;
    padding-bottom: 0;
}

.btn {
    margin-bottom: 10px;
}

.table_total_fee {
    border: 1px solid #000000;
}

.table_total_fee thead tr,
.table_total_fee thead tr th,
.table_total_fee td,
.table_total_fee th {
    border: 1px solid #000000;
}

.container {
    font-family: Times New Roman, Times, serif !important;
}

body {
    font-size: 12px !important;
}
@media print {
    .pagebreak {
        clear: both;
        page-break-after: always;
    }
}
/* remove title when print */
@page { size: auto;  margin: 0mm; }


.row {
  margin-right: 0px;
  margin-left: 0px;
}

</style>




// WEBPACK FOOTER //
// src/views/Search/SearchInvoiceInfo.vue